import { Modal, Form, Radio, Button, Select, Input } from "antd";
import DatePickerLocalised from "components/Common/DatePickerLocalised";
import { useState } from "react";
import { SpecialtyQuestionnaireModalProps, OBCodesModalProps, PainManagementModalProps, JCodeQuestionnaireModalProps } from "./Proptypes";

const SpecialtyQuestionnaireModal = ({ handleSubmit, selectedProvider, reminderText, ...rest }: SpecialtyQuestionnaireModalProps) => {

  const [form] = Form.useForm();

  const onSubmit = () => {
    form.validateFields().then(values => {
      handleSubmit(values);
    });
  }

  const OphthalmologyForm = () => {
    return (
      <Form form={form} name={'ophthalmologyForm'} onFinish={onSubmit}>

        <Form.Item
          name="referral"
          labelCol={{ span: 24 }}
          label={<>1. Is this a referral for one of the below specialist? Please check one,<br />if applicable. Skip if not applicable.</>}
        >
          {/* TODO: Checkbox group */}
          <Radio.Group>
            <Radio value={'Glaucoma'}>Glaucoma</Radio>
            <Radio value={'Corneal'}>Corneal</Radio>
            <Radio value={'Oculoplastic'}>Oculoplastic</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name="secondOpinion"
          labelCol={{ span: 24 }}
          label={<>2. Is this a second opinion to another Ophthalmologist?</>}
          rules={[{ required: true, message: 'Required.' }]}
        >
          <Radio.Group>
            <Radio value={'Yes'}>Yes</Radio>
            <Radio value={'No'}>No</Radio>
          </Radio.Group>
        </Form.Item>

      </Form>
    )
  };

  const OptometryForm = () => {
    return (
      <Form
        form={form}
        name={'optometryForm'}
        onFinish={onSubmit}
        initialValues={{
          benefitCheck: 'Yes',
          routine: 'Yes'
        }}
      >

        <Form.Item
          name="benefitCheck"
          labelCol={{ span: 24 }}
          label={<>1. Is this for a vision screening and glasses? (would require benefit check)</>}
          rules={[{ required: true, message: 'Required.' }]}
        >
          <Radio.Group>
            <Radio value={'Yes'}>Yes</Radio>
            <Radio value={'No'}>No</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name="screening"
          labelCol={{ span: 24 }}
          label={<>2. Is this for a routine vision screening?</>}
          rules={[{ required: true, message: 'Required.' }]}
        >
          <Radio.Group>
            <Radio value={'Yes'}>Yes</Radio>
            <Radio value={'No'}>No</Radio>
          </Radio.Group>
        </Form.Item>

      </Form>
    );
  };

  const CapProgramNotice = () => {
    return (
      <>
      {reminderText}
      </>
    )
  }

  return (
    <Modal
      {...rest}
      footer={[
        <Button
          type="primary"
          onClick={onSubmit}
        >
          OK
        </Button>
      ]}
    >

      {rest.title === 'Reminder' && <CapProgramNotice />}
      {rest.title === 'Ophthalmology Questionnaire' && <OphthalmologyForm />}
      {rest.title === 'Optometry Questionnaire' && <OptometryForm />}

    </Modal>
  );
};

const OBCodesModal = ({ setOBCodeSelection, OBCodeSelection, ...rest }: OBCodesModalProps) => {

  return (
    <Modal
      {...rest}
    >

      <Select
        style={{
          width: '100%',
        }}
        value={OBCodeSelection}
        onSelect={value => setOBCodeSelection(value)}
      >
        <Select.Option key={"59400"} value={"59400"}>
          59400
        </Select.Option>
        <Select.Option key={"59410"} value={"59410"}>
          59410
        </Select.Option>
        <Select.Option key={"59510"} value={"59510"}>
          59510
        </Select.Option>
        <Select.Option key={"59610"} value={"59610"}>
          59610
        </Select.Option>

        <Select.Option key={"59515"} value={"59515"}>
          59515
        </Select.Option>
        <Select.Option key={"59612"} value={"59612"}>
          59612
        </Select.Option>
        <Select.Option key={"59409"} value={"59409"}>
          59409
        </Select.Option>
        <Select.Option key={"59514"} value={"59514"}>
          59514
        </Select.Option>
      </Select>

    </Modal>
  );
};

const PainManagementModal = ({ companyId, handleSubmit, isFetchingProviderList, ...rest }: PainManagementModalProps) => {

  const [form] = Form.useForm();

  const onSubmit = () => {
    form.validateFields().then(values => {
      handleSubmit(values);
    })
  };

  return (
    <Modal
      {...rest}
      onOk={onSubmit}
      maskClosable={false}
      footer={[
        <Button
          onClick={rest.onCancel}
        >
        Cancel
        </Button>,
        <Button
          type="primary"
          onClick={onSubmit}
          disabled={isFetchingProviderList}
        >
          Submit
        </Button>
      ]}
    >
      <Form
        form={form}
        name={'painManagementForm'}
        onFinish={onSubmit}
      >
        {!['APC', 'AVISTA', 'ALPHA'].includes(companyId) ?
          <>
          <Form.Item
            name="pain"
            labelCol={{ span: 24 }}
            label={<>1. Is this request related to musculoskeletal pain?</>}
            rules={[{ required: true, message: 'Required.' }]}
          >
            <Radio.Group>
              <Radio value={true}>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            name="fracture"
            labelCol={{ span: 24 }}
            label={<>2. Is this due to new fracture or trauma?</>}
            rules={[{ required: true, message: 'Required.' }]}
          >
            <Radio.Group>
              <Radio value={true}>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            name="deficit"
            labelCol={{ span: 24 }}
            label={<>3. Acute neurological deficit?</>}
            rules={[{ required: true, message: 'Required.' }]}
          >
            <Radio.Group>
              <Radio value={true}>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            name="olderThanFourteen"
            labelCol={{ span: 24 }}
            label={<>4. Is this patient older than 14?</>}
            rules={[{ required: true, message: 'Required.' }]}
          >
            <Radio.Group>
              <Radio value={true}>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>
          </>
          :
          <>
          <Form.Item
            name="fracture"
            labelCol={{ span: 24 }}
            label={<>1. Is this due to new fracture or trauma?</>}
            rules={[{ required: true, message: 'Required.' }]}
          >
            <Radio.Group>
              <Radio value={true}>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            name="olderThanFourteen"
            labelCol={{ span: 24 }}
            label={<>2. Is this patient older than 14?</>}
            rules={[{ required: true, message: 'Required.' }]}
          >
            <Radio.Group>
              <Radio value={true}>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>
          </>
        }
      </Form>

    </Modal>
  );
};

const JCodeQuestionnaireModal = ({ handleSubmit, ...rest }: JCodeQuestionnaireModalProps) => {

  const [form] = Form.useForm();
  const [treatmentDate, setTreatmentDate] = useState('');
  const [treatmentType, setTreatmentType] = useState('');

  const onSubmit = () => {
    form.validateFields().then(values => {
      const result =
        "1. Medication name: " + (values.medicationName || '') + "\n" +
        " " + treatmentType + (treatmentType === "Continued Treatment" ? " Date Started: " + treatmentDate + "\n" : "\n") +
        "2. Dosage: " + (values.dosage || '') + "\n" +
        "3. Frequency of the medication: " + (values.frequency || '') + "\n" +
        "4. Estimated length of the therapy: " + (values.estimatedLength || '') + "\n" +
        "5. Injectable: " + (values.injectable || '') + "\n" +
        "6. Infusions: " + (values.infusions || '') + "\n" +
        "7. Setting: " + (values.setting || '') + "\n" +
        "8. What prior medication has the member tried for this condition?: " + "\n" +
        " Name of medication: " + (values.priorMedicationName || '') + "\n" +
        " Duration of the therapy: " + (values.priorMedicationDuration || '') + "\n" +
        " Response - reason for failure: " + (values.priorMedicationResponse || '') + "\n" +
        "9. Clinical information required: " + "\n" +
        " Member's symptoms: " + (values.memberSymptoms || '') + "\n" +
        " Labs results with dates: " + (values.labResults || '') + "\n" +
        " Any other relevant clinical information: " + (values.otherInfo || '') + "\n";
      handleSubmit(result);
    })
  };

  return (
    <Modal
      {...rest}
      onOk={onSubmit}
      maskClosable={false}
      width={750}
      cancelButtonProps={{ style: { display: 'none' }}}
      closable={false}
    >
      <Form
        form={form}
        name={'jCodeQuestionnaire'}
        onFinish={onSubmit}
      >
        <Form.Item
          name="medicationName"
          label={<>1. Medication Name</>}
        >
          <Input />
        </Form.Item>

        <Radio.Group onChange={e => setTreatmentType(e.target.value)} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '25px' }}>
          <Radio value={"New Treatment"}>New Treatment</Radio>
          <Radio value={"Continued Treatment"}>Continued Treatment Date Started:</Radio>
          <DatePickerLocalised
            date={treatmentDate}
            setDate={setTreatmentDate}
            disabled={treatmentType !== 'Continued Treatment'}
          />
        </Radio.Group>

        <Form.Item
          name="dosage"
          label={<>2. Dosage</>}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="frequency"
          label={<>3. Frequency of the medication</>}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="estimatedLength"
          label={<>4. Estimated length of the therapy</>}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="injectable"
          label={<>5. Injectable</>}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="infusions"
          label={<>6. Infusions</>}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="setting"
          label={<>7. Setting</>}
          labelCol={{ span: 24 }}
        >
          <Radio.Group>
            <Radio value={"Physician's office"}>Physician's office</Radio>
            <Radio value={"Patient's home"}>Patient's home</Radio>
            <Radio value={"Home health to administer"}>Home health to administer</Radio>
            <Radio value={"Out patient setting"}>Out patient setting</Radio>
          </Radio.Group>
        </Form.Item>

        8. What prior medication has the member tried for this condition?
        <Form.Item
          name="priorMedicationName"
          label={<>Name of Medication</>}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="priorMedicationDuration"
          label={<>Duration of the therapy</>}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="priorMedicationResponse"
          label={<>Response - reason for failure</>}
        >
          <Input />
        </Form.Item>

        9. Clinical information required:
        <Form.Item
          name="memberSymptoms"
          label={<>Member's symptoms</>}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="labResults"
          label={<>Labs results with dates</>}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="otherInfo"
          label={<>Any other relevant clinical information</>}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

const VendorProviderInputModal = ({ handleSubmit, ...rest }: JCodeQuestionnaireModalProps) => {

  const [form] = Form.useForm();

  const onSubmit = () => {
    form.validateFields().then(values => {
      const result = "Requesting Provider: " + (values.lastName || '') + ", " + (values.firstName || '') + "\n";
      handleSubmit(result);
    });
  };

  return (
    <Modal
      {...rest}
      onOk={onSubmit}
      maskClosable={false}
      width={750}
      cancelButtonProps={{ style: { display: 'none' }}}
      closable={false}
      title={<>Please enter the requesting provider's name</>}
    >
      <Form
        form={form}
        name={'VendorProviderInputModal'}
        onFinish={onSubmit}
      >
        <div className="row">
        <div className="col-12">
        <Form.Item
          name="lastName"
          label={<>Last Name</>}
          labelCol={{ span: 24 }}
          rules={[{ required: true, message: 'Required.' }]}
        >
          <Input />
        </Form.Item>
        </div>

        <div className="col-12">
        <Form.Item
          name="firstName"
          label={<>First Name</>}
          labelCol={{ span: 24 }}
          rules={[{ required: true, message: 'Required.' }]}
        >
          <Input />
        </Form.Item>
        </div>
        </div>
      </Form>
    </Modal>
  );
};

export { SpecialtyQuestionnaireModal, OBCodesModal, PainManagementModal, JCodeQuestionnaireModal, VendorProviderInputModal };